import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom'

export const PrivateRoute = ({
     isAuthenticated,
     component: Component,
     propComp,
     redirect,
     ...rest
}) => {

    const propComponent = propComp ? propComp : {};
    const prop = rest?.location?.hash ? { ...propComponent , hash : rest.location.hash} : propComponent;
    
    return (
        <Route { ...rest }
            component={ (props) => (
                
                ( isAuthenticated )
                ? ( <Component { ...props } {...prop} />)
                : ( window.location.href = redirect ? redirect : "https://app.iproveedor.com/login/")
            )}

        />
    )
}

PrivateRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}
